module.exports = __webpack_public_path__ + "static/media/bingo-ball_03.a8f4cca7.png";